import { combineEpics } from 'redux-observable';
import notificaitonEpic from './notificaitonEpic';

export default combineEpics(notificaitonEpic);
